import { composeGuards, redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';
import { redirectWithMainEventScope } from '@/app/shared/utils/router-guards/mainEvent';

const BASE_PATH = '/settings';

const SettingsRoutes = [
    {
        name: 'EntitiesList',
        path: `${BASE_PATH}/entities`,
        component: () => import('@/app/modules/settings/entities/EntitiesList.vue'),
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.entities.list),
    },
    {
        name: 'AddNewEntity',
        path: `${BASE_PATH}/entities/add`,
        component: () => import('@/app/modules/settings/entities/CreateEditEntity.vue'),
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.entities.addEdit),
    },
    {
        name: 'EditEntity',
        path: `${BASE_PATH}/entities/:entityId/edit`,
        component: () => import('@/app/modules/settings/entities/CreateEditEntity.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.entities.addEdit),
    },
    {
        name: 'Translations',
        path: `${BASE_PATH}/translations`,
        component: () =>
            import('@/app/modules/settings/translations/Translations/Translations.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.translations.list
        ),
    },
    {
        name: 'SeatTagsMainEventsList',
        path: `${BASE_PATH}/seat-tags/main-events`,
        component: () =>
            import('@/app/modules/settings/seatTags/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized((permissions) => permissions.settings.seatTags),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'SeatTagsVenuesList',
                params: { mainEventId },
            }))
        ),
    },
    {
        name: 'SeatTagsVenuesList',
        path: `${BASE_PATH}/seat-tags/main-events/:mainEventId/venues`,
        component: () => import('@/app/modules/settings/seatTags/VenuesList/VenuesList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.settings.seatTags),
    },
    {
        name: 'SeatTagsList',
        path: `${BASE_PATH}/seat-tags/main-events/:mainEventId/venues/:venueId/seat-tags`,
        component: () => import('@/app/modules/settings/seatTags/SeatTagsList/SeatTagsList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.settings.seatTags),
    },
    {
        name: 'ParticipantGroupsMainEventsList',
        path: `${BASE_PATH}/participant-groups/main-events`,
        component: () =>
            import('@/app/modules/settings/participantGroups/MainEventsList/MainEventsList.vue'),
        props: true,
        beforeEnter: composeGuards(
            redirectIfUnauthorized((permissions) => permissions.settings.participantGroups),
            redirectWithMainEventScope((mainEventId) => ({
                name: 'ParticipantGroupsList',
                params: { mainEventId },
            }))
        ),
    },
    {
        name: 'ParticipantGroupsList',
        path: `${BASE_PATH}/participant-groups/main-events/:mainEventId/participant-groups`,
        component: () =>
            import(
                '@/app/modules/settings/participantGroups/ParticipantGroupsList/ParticipantGroupsList.vue'
            ),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.participantGroups
        ),
    },
];

export default SettingsRoutes;
